module.exports = __webpack_public_path__ + "img/pdf.22505b8.svg";